import { connect } from 'react-redux'

import { setCardProlonge } from '../../components/Basket/reducer'
import { findCinemaId, findEventId } from '../../global/helpers'
import { paymentStart, reservationStart, setGoPayVariant, setPayment } from './reducer'

const mapStateToProps = (state) => {
    const { firstname, lastname, phone, email } = state?.services?.user || {}
    const eventid = findEventId(state)
    const cinemaid = findCinemaId(state)

    return {
        isAuth: state?.services?.auth?.isAuthorized,
        loading: state?.pages?.orderSummary?.loading ?? false,
        error: state?.pages?.orderSummary?.error ?? null,
        basket: state?.components?.basket?.data ?? null,
        selectedPayment: state?.components?.basket?.data?.selected_payment ?? null,
        emptyBasket: !state?.components?.basket?.data?.items_tickets?.length ?? false,
        isClubMember: state?.services?.user?.loyalty_program?.card?.is_valid,
        isExpiring: state?.services?.user?.loyalty_program?.card?.is_expiring,
        accountPoints: state?.services?.user?.loyalty_program?.points,
        cardValidity: state?.services?.user?.loyalty_program?.card?.validity,
        goPayVariant: state?.pages?.orderSummary?.goPayVariant,
        userAuthInfo: { firstname, lastname, phone, email },
        eventid,
        cinemaid,
    }
}

const mapDispatchToProps = { paymentStart, reservationStart, setPayment, setCardProlonge, setGoPayVariant }

const hocOrderSummary = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocOrderSummary
